import React from 'react'

const HomeWorkingProcess = () => {
    return (
        <>
            <div className='page-wraper -bar-wrapper' style={{ overflow: "hidden", marginTop: "-90px" }}>
                <section className="modern-one">
                    <div className="modern-one_pattern" style={{ backgroundImage: 'url(assets/images/background/pattern-2.png)' }} />
                    <div className="auto-container">
                        <div className="row clearfix">
                            <div className="modern-one_content-column col-lg-6 col-md-12 col-sm-12">
                                <div className="modern-one_content-inner">
                                    <div className="sec-title">
                                        <div className="sec-title_title">We Care For You.</div>
                                        <h2 className="sec-title_heading">Your speedy recovery is our top priority…</h2>
                                        <div className="sec-title_text">Satna Swastik Hospital is the best  hospital in Satna, offering world-class healthcare services. We are pioneers in delivering world-class medical treatments, specialized procedures, and intensive care at affordable costs.</div>
                                        <div className="sec-title_text">When a patient visits from overseas, he wants his treatment to go smoothly. At Satna Swastik Hospital, we do everything we can to make your stay unforgettable. With an emphasis on the needs of each individual patient, our department of foreign patient care strives to offer you smooth services.</div>
                                    </div>
                                    <div className="about-one_content-column col-lg-12 col-md-12 col-sm-12" style={{marginTop:"-60px"}}>
                                        <div className="about-one_content-inner-column">
                                            <div className="row clearfix">
                                                <div className="column col-lg-6 col-md-6 col-sm-12">
                                                    <ul className="about-one_list">
                                                        <li>Experienced team of doctors, nurses, and staff.</li>
                                                        <li>International Travel Desk & Interpreter service.</li>
                                                    </ul>
                                                </div>
                                                <div className="column col-lg-6 col-md-6 col-sm-12">
                                                    <ul className="about-one_list">
                                                        <li>Well-equipped and comfortable rooms.</li>
                                                        <li>Friendly and reliable services.</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="about-one_button">
                                                <a to="about.html" className="theme-btn btn-style-one">
                                                    <span className="btn-wrap" >
                                                        <span className="text-one">View More</span>
                                                        <span className="text-two">View More</span>
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="modern-one_image-column col-lg-6 col-md-12 col-sm-12">
                                <div className="modern-one_image-inner">
                                    <div className="modern-one_image">
                                        <img src="assets/img/about_2.webp" alt />
                                    </div>
                                    <div className="counter-one" style={{ backgroundImage: 'url(assets/images/background/pattern-5.png)' }}>
                                        <div className="row clearfix">

                                            <div className="counter-one_block col-lg-4 col-md-6 col-sm-6">
                                                <div className="counter-one_inner">
                                                    <span className="counter-one_icon flaticon-doctor" />
                                                    <div className="counter-one_counter d-flex"><span className="odometer odometer-auto-theme" ><div className="odometer-inside"><span className="odometer-digit">1<span className="odometer-digit-spacer"></span><span className="odometer-digit-inner"><span className="odometer-ribbon"><span className="odometer-ribbon-inner"><span className="odometer-value"></span></span></span></span></span></div></span></div>
                                                    <div className="counter-one_text">Year Experience</div>
                                                </div>
                                            </div>

                                            <div className="counter-one_block col-lg-4 col-md-6 col-sm-6">
                                                <div className="counter-one_inner">
                                                    <span className="counter-one_icon flaticon-medical-team" />
                                                    <div className="counter-one_counter d-flex">9+<span className="odometer odometer-auto-theme" data-count={225}><div className="odometer-inside"><span className="odometer-digit"><span className="odometer-digit-spacer"></span><span className="odometer-digit-inner"><span className="odometer-ribbon"><span className="odometer-ribbon-inner"><span className="odometer-value"> </span></span></span></span></span></div></span></div>
                                                    <div className="counter-one_text">100% Expert Doctors</div>
                                                </div>
                                            </div>

                                            <div className="counter-one_block col-lg-4 col-md-6 col-sm-6">
                                                <div className="counter-one_inner">
                                                    <span className="counter-one_icon flaticon-surgery-room" />
                                                    <div className="counter-one_counter d-flex"><span className="odometer odometer-auto-theme" data-count={2150}><div className="odometer-inside"><span className="odometer-digit"> 600+<span className="odometer-digit-spacer"></span><span className="odometer-digit-inner"><span className="odometer-ribbon"><span className="odometer-ribbon-inner"><span className="odometer-value"></span></span></span></span></span></div></span></div>
                                                    <div className="counter-one_text">Happy Patients</div>
                                                </div>
                                            </div>



                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        </>
    )
}

export default HomeWorkingProcess